module.exports = __webpack_public_path__ + "static/media/logo__0004_MGMResorts.e8fdf612.png";